import React from "react";

export default function AllStatusLabels({ status_id }) {
  if (!status_id) return null;

  const statusIds = Array.isArray(status_id)
    ? status_id.map(Number)
    : [Number(status_id)];

  let label = "Applied";
  let className = "applied";

  if (statusIds.some(id => [11].includes(id))) {
    label = "Submitted";
    className = "submitted";
  } else if (statusIds.some(id => [2, 22, 4, 24].includes(id))) {
    label = "Declined";
    className = "declined";
  } else if (statusIds.some(id => [3, 23, 5, 25].includes(id))) {
    label = "Accepted";
    className = "accepted";
  } else if (statusIds.some(id => [12, 13, 14, 15].includes(id))) {
    label = "Awarded";
    className = "awarded";
  }

  return (
    <p className={`post-applied mx-auto ${className}`}>
      {label}
    </p>
  );
}
